import { Box } from '@mui/material';
import type { FC } from 'react';
import { PLACEHOLDER_IMAGE } from '../../helpers/placeholderImages';

type FocusLeePlaceholderImageProps = {
    kind: keyof typeof PLACEHOLDER_IMAGE;
    size?: number;
};

export const FocusLeePlaceholderImage: FC<FocusLeePlaceholderImageProps> = ({ kind, size = 144 }) => (
    <Box component="img" src={PLACEHOLDER_IMAGE[kind]} alt="" sx={{ width: size, height: size, display: 'block', objectFit: 'contain' }} />
);
